'use client';

import { useState, type ReactNode } from 'react';
import { ReviewsPanel } from './ReviewsPanel';
import { useT } from '@/hooks/useT';

interface Props {
  aboutPanel: ReactNode;
  morePanel: ReactNode;
  productId: string;
  reviewCount: number;
}

export function ContentTabs({ aboutPanel, morePanel, productId, reviewCount }: Props) {
  const [tab, setTab] = useState<'about' | 'sysreq' | 'reviews'>('about');
  const t = useT();

  const btnStyle = (id: string): React.CSSProperties => ({
    padding: '11px 20px', border: 'none', background: 'none',
    fontSize: 13, fontWeight: 700, cursor: 'pointer', whiteSpace: 'nowrap' as const,
    flexShrink: 0, borderBottom: `2px solid ${tab === id ? 'var(--gs-green)' : 'transparent'}`,
    marginBottom: -1, color: tab === id ? 'var(--gs-green)' : 'var(--v4-fg-3)',
    transition: 'color .18s', letterSpacing: 0,
  });

  return (
    <div>
      <div className="ctab-bar" style={{ display: 'flex', alignItems: 'center', borderBottom: '1px solid var(--v4-border)', marginBottom: 18, overflow: 'clip' }}>
        <button className={`ctab${tab === 'about' ? ' active' : ''}`} style={btnStyle('about')} onClick={() => setTab('about')}>{t('pdp_tab_details')}</button>
        <button className={`ctab${tab === 'sysreq' ? ' active' : ''}`} style={btnStyle('sysreq')} onClick={() => setTab('sysreq')}>{t('pdp_tab_more')}</button>
        <button className={`ctab${tab === 'reviews' ? ' active' : ''}`} style={btnStyle('reviews')} onClick={() => setTab('reviews')}>
          {t('pdp_tab_reviews')}
          {reviewCount > 0 && (
            <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', minWidth: 18, height: 16, borderRadius: 999, background: 'rgba(82,176,67,.15)', color: 'var(--gs-green)', fontSize: 9, fontWeight: 800, padding: '0 4px', marginLeft: 5, verticalAlign: 'middle' }}>
              {reviewCount}
            </span>
          )}
        </button>
      </div>

      <div style={{ display: tab === 'about' ? 'flex' : 'none', flexDirection: 'column', gap: 16 }}>
        {aboutPanel}
      </div>
      <div style={{ display: tab === 'sysreq' ? 'block' : 'none' }}>
        {morePanel}
      </div>
      <div style={{ display: tab === 'reviews' ? 'block' : 'none' }}>
        <ReviewsPanel productId={productId} visible={tab === 'reviews'} />
      </div>
    </div>
  );
}
